import request from '@/utils/request'

export function insertOrUpdateImplementatio(data) {
	return request({
		url: '/acode/api/implementation/insertOrUpdate',
		method: 'post',
		data
	})
}
export function deleteImplementatio(params) {
	return request({
		url: 'acode/api/implementation/deleteById',
		method: 'delete',
		params
	})
}

export function getImplementationList(data) {
	return request({
		url: '/acode/api/implementation/getPageList',
		method: 'post',
		data
	})
}

export function getMalfunction() {
	return request({
		url: '/acode/api/user/malfunction/list',
		method: 'get'
	})
}

export function getMalfunctionInfoByImplementatioId(params){
	return request({
		url: '/acode/api/implementation/getMalfunctionList',
		method: 'get',
		params
	})
}